<template>
  <div id="app">
    <v-app>
      <Header></Header>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
/* eslint-disable */
import InputInventory from './components/InputInventory.vue'
import Top from './components/Top.vue'
import Login from './components/Login.vue'
import Header from './components/Header.vue'
import TenpoSelect from './components/TenpoSelect.vue'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'App',
  components: {
    InputInventory,
    Top,
    Login,
    TenpoSelect,
    Header,
    Spinner
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
  touch-action: manipulation;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
}

/* custom v-select */
.vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(0.75) !important;
}

.vs__open-indicator {
  transform: scale(0.75) !important;
}

.vs__search::placeholder {
  color: rgb(60, 60, 60);
  opacity: 0.5;
}

/* custom v-select with class custom-select */
.v-select.custom-select {
  font-size: 20px;
}

.v-select.custom-select .vs__selected,
.v-select.custom-select .vs__search,
.v-select.custom-select .vs__search:focus {
  margin-top: 8px;
}

.v-select.custom-select .vs__dropdown-toggle {
  padding-bottom: 8px;
}

.v-select.custom-select .vs__clear {
  margin-top: -4px;
  padding: 0 8px;
}

.v-select.custom-select .vs__actions {
  padding-top: 8px;
}

/* custom autocomplete */
.v-input.custom-autocomplete {
  font-size: 14px;
}

.custom-autocomplete .v-text-field__details {
  min-height: 0 !important;
}

.custom-autocomplete.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}

.custom-autocomplete .v-text-field__details .v-messages {
  min-height: 0 !important;
}

.custom-autocomplete.v-input--dense>.v-input__control>.v-input__slot {
  margin-bottom: 0 !important;
}

.custom-autocomplete.v-text-field--outlined {
  border-radius: 4px;
}

.custom-autocomplete.v-text-field--outlined fieldset {
  border: 1px solid rgba(60, 60, 60, 0.26);
}

.custom-autocomplete.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
  min-height: 32px;
  padding: 0 8px;
}

.custom-autocomplete.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
  margin-top: 4px;
}

.custom-autocomplete.v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
  transform: rotate(0);
}

.custom-autocomplete.v-text-field input {
  padding: 4px 0 4px;
}

.v-autocomplete__content .v-list--dense .v-list-item .v-list-item__title {
  font-size: 13px;
  text-align: left;
}

/** responsive for tablet autocomplete */
@media only screen and (min-width: 960px) {
  .v-input.custom-autocomplete {
    font-size: 18px;
  }

  .custom-autocomplete.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: 37px;
    padding: 0 8px;
  }

  .custom-autocomplete.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
    margin-top: 6px;
  }

  .v-autocomplete__content .v-list--dense .v-list-item .v-list-item__title {
    font-size: 17px;
    text-align: left;
  }

  .vs__actions .vs__clear {
    margin-right: 12px !important;
  }
}

/** responsive for tablet */
@media only screen and (min-width: 960px) {
  #app {
    font-size: 18px;
  }

  .v-btn.v-size--large {
    font-size: 18px;
  }
}
</style>
